<template>
    <div>
    <div class="mask" v-show="timepickershow || dateboxshow"></div>


    <div class="timebox" v-show="timepickershow">
        <div class="timeboxwrapper">
            <div class="title">
                选择时间范围
                <p>时间范围请勿超过3个月</p>
            </div>
            
            <div class="timecontent">

                <div class="startdate">
                    <p>开始时间</p>
                    <ul>
                        <li>年</li>
                        <li>月</li>
                        <li>日</li>
                    </ul>
                    <van-datetime-picker v-model="currentDatestart" type="date" :min-date="minDate" :max-date="maxDate" @change="onchangestart" visible-item-count="3" :show-toolbar="false"/>
                </div>

                <div class="enddate">
                    <p>结束时间</p>
                    <ul>
                        <li>年</li>
                        <li>月</li>
                        <li>日</li>
                    </ul>
                    <van-datetime-picker v-model="currentDateend" type="date" :min-date="minDate" :max-date="maxDate" @change="onchangeend" visible-item-count="3" :show-toolbar="false"/>
                </div>
                
            </div>

        </div>
        <div class="timebtn">
            <p @click="confirmremove">取消</p>
            <p @click="confirmPicker">确定</p>
        </div>
    </div>

        <!-- 交易日期弹出框 -->
        <div class="databox" v-show="dateboxshow">
            <div class="title">选择挂单有效期 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
            <div class="datelist">
                <div v-for="(item,index) in datelist" :key="index" class="item" @click="handleDate(index)">{{item.title}}<img  v-show="dateselectIndex == index && showicon" src="@/assets/correct.png" alt=""></div>
            </div>
        </div>


        <div class="nav">
            <div @click="handleDates" class="left">
                <img src="@/assets/date.png" alt="">
                <span>{{datetext?datetext:'今日'}}</span>
                
            </div>
            <div class="right" @click="handleicon">
                <span>{{ordertext?ordertext:'平仓订单'}}</span>
                <img :style="{transform: !icontoggle ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/price-up.png" alt="">
                <ul class="slideDown" v-show="icontoggle">
                    <div class="tab-icon"></div>
                        <router-link class="tab-item" v-for="(tab,index) in tabs" :key="index" :to="tab.path">
                            <li @click="handleli(index)">{{tab.name}}</li>
                        </router-link>
                </ul>
            </div>
        </div>
        
    <keep-alive>
        <router-view :datetext='datetext' :changetimestart='changetimestart' :changetimeend='changetimeend'></router-view>
    </keep-alive>
        <!-- <router-view :datetext='datetext' :changetimestart='changetimestart' :changetimeend='changetimeend'></router-view> -->
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name:"historys",
    data(){
        return{
            showicon:true,
            minDate: new Date(2000, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDatestart: new Date(),
            currentDateend:new Date(),
            timepickershow:false,
            changetimestart:null,
            changetimeend:null,
            datetext:null,

            dateselectIndex:0, //交易类型选择
            dateboxshow:false, //选择交易类型弹框
            datelist:[{'id':'0','title':'今日'},{'id':'1','title':'昨日'},{'id':'2','title':'最近七日'},{'id':'3','title':'最近一个月'},{'id':'4','title':'最近三个月'},{'id':'5','title':'最近六个月'},{'id':'6','title':'自定义'}],

            icontoggle:false,
            ordertext:null,
            isup:false,//判断子组件是否刷新
            dateshow:false,

            tabs: [
                {
                    name: '平仓订单',
                    path: '/history'
                },
                {
                    name: '失效挂单',
                    path: '/history/shixiao'
                },
                {
                    name: '资金明细',
                    path: '/history/mingxi'
                }
            ]
        }
    },
    methods:{
        handleicon(){
            this.icontoggle = !this.icontoggle
        },
        handleli(index){
            this.ordertext = this.tabs[index].name
        },
        
        // 呼出日期选择框
        handleDates(){
            this.dateboxshow = true
        },
        handleDate(index){
            this.dateselectIndex = index
            this.datetext = this.datelist[index].title
            this.dateboxshow = false
            if(index == 6){
                this.timepickershow = true
                this.datetext = null
                this.timepickershow = true
                 this.showicon = false
            }else{
                this.showicon = true
            }

        },

        // 开始时间选定
        onchangestart(val){
            if(val){
                this.changetimestart = moment(val.getValues()[0]+val.getValues()[1]+val.getValues()[2]).format('YYYY-MM-DD')
            }
        },

        // 开始时间选定
        onchangeend(val){
            if(val){
                this.changetimeend = moment(val.getValues()[0]+val.getValues()[1]+val.getValues()[2]).format('YYYY-MM-DD')
            }
        },

        // 时间确认
        confirmPicker(){


            if(this.changetimestart == null){
                this.changetimestart = moment(new Date()).format('YYYY-MM-DD')
            }

            if(this.changetimeend == null){
                this.changetimeend = moment(new Date()).format('YYYY-MM-DD')
            } 

            if(this.changetimestart > this.changetimeend){

                this.$toast('开始时间不能早于结束时间')
                return false;

            }else if(this.changetimestart && this.changetimeend){

                var d = moment(new Date()).format('YYYY-MM-DD')

               if(this.changetimestart == this.changetimeend && this.changetimestart == d && this.changetimeend == d){

                    this.datetext = '今日'

                }else{
                    this.datetext = this.changetimestart + ' ~ ' + this.changetimeend
                }

            }

            this.timepickershow = false //关闭弹层


            if(window.location.href.indexOf('pingcang')>-1){
                this.$store.state.pcconfirm = true //点击平仓订单请求开关打开
            }else if(window.location.href.indexOf('shixiao')>-1){
                this.$store.state.sxconfirm = true
            }else if(window.location.href.indexOf('mingxi'>-1)){
                this.$store.state.mxconfirm = true
            }


        },

        // 时间取消
        confirmremove(){
            this.timepickershow = false
        },

        // 关闭交易类型、交易日期弹出框
        handleClose(){
            this.dateboxshow = false
        },

    },

    watch:{
        //监听地址栏变化对应(平仓订单、失效挂单、资金明细文本)
        $route:{
            handler(newVal,oldVal){
                if(newVal.fullPath.indexOf('shixiao')>-1){
                    this.ordertext = '失效挂单'
                }else if(newVal.fullPath.indexOf('mingxi')>-1){
                    this.ordertext = '资金明细'
                }else{
                    this.ordertext = '平仓订单'
                }
            }
        }
        // 'text'(val){
        //     if(window.location.href.indexOf('pingcang')){
        //         this[val] = '平仓订单'
        //     }else if(window.location.href.indexOf('shixiao')){
        //         this[val] = '失效挂单'
        //     }else if(window.location.href.indexOf('mingxi')){
        //         this[val] = '资金明细'
        //     }
        // }
    },
    mounted(){
        this.$emit('num',0)

        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

        // this.$store.state.goldindex = true ////必须，返回到交易页面由于是黄金页面所以必须重置为true，避免input黄金白银资金错乱

        // if(this.ordertext == '平仓订单'){
        //     this.$router.push({path:'/history/pingcang'})
        // }else if(this.ordertext == '失效挂单'){
        //     this.$router.push({path:'/history/shixiao'})
        // }else if(this.ordertext == '资金明细'){
        //     this.$router.push({path:'/history/mingxi'})
        // }
        // 模拟账户去掉资金明细
        if(this.$store.state.mnlogin){
            this.$delete(this.tabs,2)
        }
    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 1000;}
    .nav{height: 44px;display: flex;justify-content: space-between;align-items: center;padding: 0 12px;}
    .nav .left{display: flex;align-items: center;}
    .nav .left img{width: 16px;height: 16px;display: block;}
    .nav .left span{padding-left: 4.67px;color: #999999;font-size: 12px;}

    .nav .right{display: flex;align-items: center;position: relative;}
    .nav .right img{width: 18px;height: 18px;display: block;transform: rotate(180deg);transition: all 0.5s;}
    .nav .right span{padding-right: 6.33px;color: #999999;font-size: 12px;}

    .slideDown{width: 100px;border-radius: 6px;background: rgba(0, 0, 0, 0.6);position: absolute;right: 12px;top: 30.67px;display: flex;justify-content: center;align-items: center;flex-wrap: wrap;padding-bottom: 11.33px;z-index: 999;}
    .slideDown li{padding-top: 10px;color: #FFFFFF;font-size: 14px;}
    .tab-item{text-decoration: none;}
    .tab-icon{display: block !important;position: absolute !important;top: -7px !important;right: 15px !important;border-left: 7px solid transparent;border-right: 7px solid transparent;border-bottom: 7px solid rgba(0, 0, 0, 0.6);}

    /* timepicer */
    .timebox{background-color: #FFFFFF;position: fixed;bottom: 0;width: 100%;z-index: 2000;border-top-left-radius:12px;border-top-right-radius: 12px;}
    .timeboxwrapper{background-color: #FFFFFF;margin-top: 10px;}
    .timeboxwrapper .title{color: #333333;font-weight: bold;font-size: 16px;text-align: center;padding: 7.67px 0 21px 0;}
    .timeboxwrapper .title p{color: #999999;font-size: 12px;font-weight: normal;padding-top: 8.33px;}
    .timecontent{display: flex;justify-content: space-between;align-items: center;}
    .startdate{display: flex;flex-direction: column;flex: 1;padding: 0 8px;}
    .startdate p{color: #333333;font-size: 14px;text-align: center;padding-bottom: 21px;}
    .enddate{display: flex;flex-direction: column;flex: 1;padding: 0 8px;}
    .enddate p{color: #333333;font-size: 14px;text-align: center;padding-bottom: 21px;}
    .timebox ul{display: flex;}
    .timebox ul li{padding: 0 4px;flex: 1;display: flex;justify-content: center;color:#BBBBBB;font-size: 16px;}
    .timebtn{padding: 0 20px; margin:0 auto;display: flex;justify-content: space-between;align-items: center;margin-top: 25px;margin-bottom: 40px;}
    .timebtn p:nth-of-type(1){width: 48.3%;height: 44px;font-weight: bold;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-color: #EEEEEE;}
    .timebtn p:nth-of-type(2){width: 48.3%;height: 44px;font-weight: bold;color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-image: linear-gradient(to bottom, #FF6738, #FF4F36);}

    /* 选择交易日期 */
    .databox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 9999999999999999999;padding-bottom: 30px;}
    .databox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .databox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .databox .datelist{padding-left: 20.33px}
    .databox .datelist .item{border-bottom: 1px solid #F5F5F5;height: 45px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .databox .datelist .item img{width: 24px;height: 24px;display: block;margin-right: 15px;}

</style>


// WEBPACK FOOTER //
// src/pages/history.vue